import {VersionInfoComponent} from './version-info.component';
export const VersionRoutes = [
  {
    path: 'version-info',
    component: VersionInfoComponent,
  },
];
